import { ReactNode } from 'react';
import { Button, Text, useTheme } from '@simplywallst/ui-core';
import { InformationSolid } from '@simplywallst/ui-core/icons';
import { useTypeformDrawer } from '@/hooks/useTypeformDrawer';
import type { TypeformId } from '@/hooks/useTypeformDrawer';
import { BetaSection } from './styled';

interface TypeFormProps {
  typeFormId: TypeformId;
  typeFormOptions?: {
    section?: string;
    company?: string;
  };
}
interface Props extends Partial<TypeFormProps> {
  text?: string;
  customAction?: ReactNode;
}

const TypeFormAction = ({ typeFormId, typeFormOptions }: TypeFormProps) => {
  const makeTypeformPopup = useTypeformDrawer(typeFormId, typeFormOptions);
  return (
    <Button
      marginLeft
      styleType="strongLink"
      display="inline"
      onClick={makeTypeformPopup}
    >
      Give Feedback.
    </Button>
  );
};

export const CompanyReportFeedbackBar = ({
  typeFormId,
  typeFormOptions,
  text = 'This section of the company report contains some beta features.',
  customAction,
}: Props) => {
  const theme = useTheme();

  return (
    <BetaSection
      templateColumns="auto auto auto"
      gap="8px"
      justifyContent="start"
      alignItems="center"
    >
      <InformationSolid fill={theme.color.whiteRGBA(0.5)} />
      <Text typography="xSmall" color="whiteRGBA" opacity={0.8}>
        {text}
        {typeFormId && (
          <TypeFormAction
            typeFormId={typeFormId}
            typeFormOptions={typeFormOptions}
          />
        )}
        {customAction}
      </Text>
    </BetaSection>
  );
};
